import { COMPANY } from "@/config/company";

// Dominio canonico e costanti SEO centralizzate.
export const SITE_ORIGIN = COMPANY.site; // https://learnspherehub.it
export const SITE_NAME = COMPANY.brand; // LearnSphereHub
export const SUPPORT_EMAIL = COMPANY.supportEmail;
export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/logo-lsh-full.png`;

export function absoluteUrl(path = "/") {
  if (!path) return SITE_ORIGIN;
  if (/^https?:\/\//i.test(path)) return path;
  return SITE_ORIGIN + (path.startsWith("/") ? path : `/${path}`);
}

// Rimuove HTML/entità e normalizza gli spazi.
export function stripHtml(str = "") {
  return String(str)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#0?39;|&apos;/gi, "'")
    .replace(/\s+/g, " ")
    .trim();
}

// Tronca a max caratteri senza spezzare le parole a metà.
export function truncate(str = "", max = 160) {
  const clean = stripHtml(str);
  if (clean.length <= max) return clean;
  const slice = clean.slice(0, max);
  const lastSpace = slice.lastIndexOf(" ");
  const cut = lastSpace > 0 ? slice.slice(0, lastSpace) : slice;
  return cut.replace(/[\s.,;:!?–—-]+$/, "") + "…";
}

// Compone il title con il nome del sito.
export function pageTitle(base) {
  if (!base) return SITE_NAME;
  return `${base} | ${SITE_NAME}`;
}
